// src/i18n.ts
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// Definir las traducciones y sus tipos
export const resources = {
  en: {
    translation: {
      "message_products_not_found": "No products found",
      "message_reference_not_found": "No reference found",
      "message_reference_required": "Reference required",
      "message_api_url_not_found": "API URL not found"
    }
  },
  es: {
    translation: {
      "message_products_not_found": "No se encontraron productos",
      "message_reference_not_found": "No se pudo obtener la referencia",
      "message_reference_required": "Referencia requerida",
      "message_api_url_not_found": "URL de la API no encontrada"
    }
  }
};

// Inicializar i18n
i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: 'es', // Idioma predeterminado
    fallbackLng: 'es',
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;